class SliderComponent extends HTMLElement {
    constructor() {
      super();
  
      this.slider_container = this.querySelector(".grid");
      this.slider_item = this.querySelector(".slider__item");
      this.slider_item_width = this.slider_item.offsetWidth;
  
      // Add click handlers
      this.querySelectorAll(".slider__arrow--back").forEach((arrow) => {
        arrow.addEventListener("click", () => this.navigate("backward"));
      });
      this.querySelectorAll(".slider__arrow--forward").forEach((arrow) => {
        arrow.addEventListener("click", () => this.navigate("forward"));
      });
      
  
      this.querySelectorAll(".slider__dots-item")
          .forEach((dot, index) => {
              dot.addEventListener("click", () => this.navigate(index));
              // dot.addEventListener("mouseenter", () => clearInterval(autoplay));
          });
  
      // Add keyboard handlers
      this.addEventListener("keydown", (e) => {
        if (e.code === "ArrowLeft") {
          // clearInterval(autoplay);
          this.navigate("backward");
        } else if (e.code === "ArrowRight") {
          // clearInterval(autoplay);
          this.navigate("forward");
        }
      });
  
      // Add resize handler
      window.addEventListener("resize", () => {
        this.slider_item_width = this.slider_item.offsetWidth;
      });
  
      // Autoplay
      // const autoplay = setInterval(() => navigate("forward"), 3000);
      // slideContainerEl.addEventListener("mouseenter", () => clearInterval(autoplay));
  
      if(this.querySelector(".slider__dots-item")) {
        const dot = this.querySelector('.slider__dots-item:first-child');
        const dot_width = dot.offsetWidth;
        let slider_item_index = 0;
  
        this.slideObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
              if (entry.isIntersecting) {
                  slider_item_index = entry.target.dataset.slideindex;
  
                  // console.log(dot);
                  // console.log(dot_width);
                  // console.log(slider_item_index);
  
                  dot.style.transform = `translate3d(${slider_item_index * dot_width}px,0,0)`;
              }
          });
        }, { root: this.slider_container, threshold: 0.5 });
        
        this.querySelectorAll('.slider__item').forEach((slide) => {
          this.slideObserver.observe(slide);
        });
      }
      
    }
  
    getNewScrollPosition = (arg) => {
      const 
      // gap = +window
      //     .getComputedStyle(this.slider_container)
      //     .getPropertyValue("column-gap")
      //     .slice(0, 2),
        scroll_left = Math.round(this.slider_container.scrollLeft),
        slider_width = Math.round(this.slider_container.clientWidth),
        slider_scroll_width = Math.round(this.slider_container.scrollWidth),
        max_scroll_left = slider_scroll_width - slider_width;
  
      if (arg === "forward") {
        const x = scroll_left + slider_width;
        return x > max_scroll_left
          ? max_scroll_left - scroll_left < 5
            ? 0
            : max_scroll_left
          : x;
      } else if (arg === "backward") {
        const x = scroll_left - slider_width;
        return x < 0 ? (scroll_left == 0 ? max_scroll_left : 0) : x;
      }
       else if (typeof arg === "number") {
        const x = arg * this.slider_item_width;
  
        // console.log(arg);
        // console.log(x);
  
        return x;
      }
    };
    navigate = (arg) => {
      this.slider_container.scrollLeft = this.getNewScrollPosition(arg);
    };
  }
  customElements.define("slider-component", SliderComponent);